module.exports = __webpack_public_path__ + "scource/left-top-bg-b6522854.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/TeacherInfo/img/left-top-bg.png
// module id = 1200
// module chunks = 1